"use client";

import { Notification, NotificationType } from "@/types/notification";
import NotificationItem, {
  NotificationAvatar,
} from "@/components/tailwind/notification/notificationItem";
import { useWorkspaceContext } from "@/contexts/workspaceContext";

interface Props {
  notification: Notification;
}

function renderMessage(
  type: NotificationType,
  groupName: string,
  oldGroupName: string | undefined,
  workspaceName: string,
) {
  const groupChip = (
    <span className="font-medium text-gray-700 dark:text-gray-300">
      {groupName || "a group"}
    </span>
  );
  const wsChip = workspaceName ? (
    <>
      {" "}
      in{" "}
      <span className="font-medium text-gray-700 dark:text-gray-300">
        {workspaceName}
      </span>
    </>
  ) : null;

  switch (type) {
    case "GROUP_CREATED":
      return (
        <>Added you to the group {groupChip}{wsChip}</>
      );
    case "GROUP_MEMBER_ADDED":
      return (
        <>Added you to the group {groupChip}{wsChip}</>
      );
    case "GROUP_MEMBER_REMOVED":
      return (
        <>Removed you from the group {groupChip}{wsChip}</>
      );
    case "GROUP_RENAMED":
      return (
        <>
          Renamed the group{" "}
          <span className="font-medium text-gray-700 dark:text-gray-300">
            {oldGroupName || "a group"}
          </span>{" "}
          to {groupChip}{wsChip}
        </>
      );
    case "GROUP_DELETED":
      return (
        <>Deleted the group {groupChip}{wsChip}. Access via this group has been removed.</>
      );
    default:
      return <>Updated the group {groupChip}{wsChip}</>;
  }
}

export default function NotificationGroupChange({ notification }: Props) {
  const { getMemberName } = useWorkspaceContext();
  const displayName =
    getMemberName(notification.createdBy?.userId) ||
    getMemberName(notification.createdBy?.userEmail) ||
    notification.createdBy?.userName ||
    "An admin";

  const groupName = notification.context?.groupName || "";
  const oldGroupName = notification.context?.oldGroupName;

  return (
    <NotificationItem
      icon={
        <NotificationAvatar
          name={displayName}
          userId={notification.createdBy?.userId}
          email={notification.createdBy?.userEmail}
        />
      }
      createdAt={notification.createdAt}
      unread={!notification.read}
      title={displayName}
      message={renderMessage(
        notification.type,
        groupName,
        oldGroupName,
        notification.workspaceName,
      )}
    />
  );
}
